// POST Get Care Plan

export const getCarePlanConfig = () => ({
  url: `/careplan`,
});

// PUT Edit care Plan

export const editCarePlanConfig = () => ({
  url: `/careplan`,
});
